import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";

const HERO_TEXTURE_URL =
    "https://static.prod-images.emergentagent.com/jobs/7c762341-5a35-4795-b6d8-cb66f13790d4/images/f2cb976512c895ccdc2b51086292dcec210b3a25d34f8344c394a11e6fc4d238.png";

const DELIVERABLES = [
    "JD-tailored resume",
    "Cover letter in your voice",
    "30-60-90 day plan",
    "Hiring manager deep dive",
    "Mock Q&A in your voice",
    "Competitive intel one-pager",
    "Thank-you templates",
];

const Hero = () => (
    <section
        data-testid="hero-section"
        className="slate-texture relative overflow-hidden border-b border-border"
    >
        <div
            aria-hidden
            className="pointer-events-none absolute inset-0 opacity-[0.06]"
            style={{
                backgroundImage: `url(${HERO_TEXTURE_URL})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                mixBlendMode: "multiply",
            }}
        />
        <div className="relative mx-auto grid max-w-7xl gap-16 px-6 py-24 md:grid-cols-12 md:px-10 md:py-32">
            <div className="md:col-span-8">
                <p
                    data-testid="hero-eyebrow"
                    className="slate-fade-up text-xs uppercase tracking-[0.3em] text-muted-foreground"
                >
                    Application → Interview → Offer
                </p>
                <h1
                    data-testid="hero-headline"
                    className="slate-fade-up slate-delay-1 mt-6 font-serif text-5xl font-medium leading-[1.02] tracking-tighter text-foreground md:text-7xl lg:text-[88px]"
                >
                    The campaign system
                    <br />
                    senior leaders
                    <span className="italic"> actually use </span>
                    <br />
                    to land their next role.
                </h1>
                <p
                    data-testid="hero-subhead"
                    className="slate-fade-up slate-delay-2 mt-8 max-w-2xl text-base text-muted-foreground md:text-lg"
                >
                    A JD-tailored, ATS-optimized resume that gets you the interview — and a
                    hiring-manager-specific kit that helps you close it. Tailored to your
                    role, your resume, and the people sitting across the table.
                </p>

                <div className="slate-fade-up slate-delay-3 mt-12 flex flex-wrap items-center gap-5">
                    <Link
                        to="/apply"
                        data-testid="hero-cta-primary"
                        className="inline-flex items-center gap-3 rounded-sm border border-primary bg-primary px-7 py-3.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-foreground"
                    >
                        Start a Campaign
                        <ArrowRight size={16} strokeWidth={1.5} />
                    </Link>
                    <a
                        href="#case-study"
                        data-testid="hero-cta-secondary"
                        className="slate-link inline-flex items-center gap-2 text-sm text-foreground"
                    >
                        See how Maggie used it
                        <ArrowRight size={14} strokeWidth={1.5} />
                    </a>
                </div>

                <div className="slate-fade-up slate-delay-4 mt-16 flex flex-wrap items-center gap-x-10 gap-y-3 text-xs uppercase tracking-[0.25em] text-muted-foreground">
                    <span>Built for Director, VP, and SVP transitions</span>
                    <span className="hidden md:inline">·</span>
                    <span>Delivered in 48 hours</span>
                </div>
            </div>

            <div className="hidden md:col-span-4 md:block">
                <div className="relative">
                    <div className="absolute -inset-3 border border-border" aria-hidden />
                    <div className="relative bg-card p-10">
                        <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">
                            What you get
                        </p>
                        <ul className="mt-6 space-y-4 text-sm">
                            {DELIVERABLES.map((item) => (
                                <li key={item} className="flex items-start gap-3">
                                    <CheckCircle2 size={16} strokeWidth={1.5} className="mt-0.5 shrink-0 text-foreground" />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                        <p className="mt-8 font-serif text-lg italic text-muted-foreground">
                            &ldquo;A clean slate for your next chapter.&rdquo;
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Hero;
